import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import '@arco-design/web-react/dist/css/arco.css';
import enUS from '@arco-design/web-react/es/locale/en-US';
import './App.css';
import './assets/font-awesome/css/all.min.css';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import './assets/css/config.css';
import './assets/css/common.css';
import './assets/css/style.css';
import './styles/layout.css';
import './common/config/globalVariable';
import AppRoutes from './components/routes/AppRoutes';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import { ConfigProvider } from '@arco-design/web-react';
import { AlertProvider } from './common/Context/AlertContext';
import GlobalStateProvider from './common/Context/GlobalContext/GlobalStateProvider';
import { AuthProvider } from './common/Context/AuthContext';
import { LoaderProvider } from './common/Context/LoaderContext';
import ScrollToTop from './components/scrollToTop/ScrolToTop';
import ToastProvider from './components/ToastProvider/ToastProvider';
import { CreditProvider } from './common/Context/CreditContext';
import { getUTMParams, setLocalStorage } from './common/Utils/Utils';

function App() {
  useEffect(() => {
    const utmData = getUTMParams();

    // Store only if present
    if (utmData.utm_source || utmData.source_page) {
      setLocalStorage('utm_data', JSON.stringify(utmData));
    }
  }, []);
  return (
    <ConfigProvider locale={enUS}>
      <AuthProvider>
        <AlertProvider>
          <GlobalStateProvider>
            <LoaderProvider>
              <CreditProvider>
                <ToastProvider />
                <Router basename={'/'}>
                  <ScrollToTop /> {/* 👈 Add here */}
                  <div className="App d-flex flex-column min_svh_100 overflow-auto scrollbar1 svh_100">
                    <Header />
                    <main className="flex-grow-1">
                      <AppRoutes />
                    </main>
                    <Footer />
                  </div>
                </Router>
              </CreditProvider>
            </LoaderProvider>
          </GlobalStateProvider>
        </AlertProvider>
      </AuthProvider>
    </ConfigProvider>
  );
}

export default App;
